export class PlaylistSwitchedResponse {
    static Message = 'PlaylistSwitchedResponse';

    public previousPlaylist: string;
    public newPlaylist: string;

    constructor(previousPlaylist: string, newPlaylist: string) {
        this.previousPlaylist = previousPlaylist;
        this.newPlaylist = newPlaylist;
    }
}
